import React, { useEffect } from 'react';
import { Switch, FormControlLabel, FormGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../../theme/colors';
import { useLocation, useNavigate } from 'react-router-dom';
const HOME_COACH = `/${process.env.REACT_APP_HOME_COACH}`
const HOME_PLAYER = `/${process.env.REACT_APP_HOME_PLAYER}`

const SwitchContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '200px', // Ajuste o tamanho conforme necessário
}));

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    color: colors.background.error, // Cor do Switch quando desativado
    '&.Mui-checked': {
      color: colors.background.success, // Cor do Switch quando ativado
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: colors.background.success, // Cor da trilha do Switch quando ativado
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: colors.background.error, // Cor da trilha do Switch quando desativado
  },
}));

const CustomSwitchComponent = () => {
  const [checked, setChecked] = React.useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event:any) => {
    let switchEvent = event.target.checked;
    setChecked(switchEvent);
    if(switchEvent)navigate(`${HOME_COACH}`)
      else navigate(`${HOME_PLAYER}`)
  };
  

  useEffect(() => {
    if (location.pathname === HOME_COACH) {
      setChecked(true);
    } else if (location.pathname === HOME_PLAYER) {
      setChecked(false);
    }
  }, [location.pathname]);

  return (
    <SwitchContainer>
      <span style={{ transform: "translateX(-10px)", color:colors.background.error,fontSize:"20px" }}>Jogador</span>
      <FormGroup style={{ margin: 0 }}>
        <FormControlLabel
          control={
            <CustomSwitch
              checked={checked}
              onChange={handleChange}
            />
          }
          label=""
        />
      </FormGroup>
      <label style={{ transform: "translateX(-20px)",color:colors.background.success,fontSize:"20px" }}>Treinador</label>
    </SwitchContainer>
  );
};

export default CustomSwitchComponent;
